'use strict';

angular.module('Directives').directive('ngSelect2', function($timeout) {
    return {
        'restrict': 'A',
        'require': 'ngModel',
        'scope': {
            ngModel: '=',
            selectOptions: '=ngItems'
        },
        'link': function linkingFunction($scope, element, attr) {
            $timeout(function(){
                element.select2();
            });
            $scope.$watch('ngModel', function(o, n) {
                $timeout(function() {
                    element.select2();
                });
            });
        },
        'controller': function($scope) {
        }
    }
});


// WEBPACK FOOTER //
// ./js/directives/select2.js